import { GridEditInputCell } from "@mui/x-data-grid-pro";
import React, { useCallback, useEffect, useState, useMemo } from "react";

import { putDataWAuth } from "../../utils/api-service";
import DataGrid from "../../common/data-grid/data-grid";
import GridToolbar from "../../common/data-grid/grid-toolbar";
import {
  APP_VIEW,
  IB_BKP_EDIT_RATES,
  IB_BKP_FRZ_RATES,
} from "../../constants/constant";
import ToastMessageFunction from "../../common/toast-message-function";
import { HorizontalRuleRounded } from "@mui/icons-material";
import { useTranslation } from "../../common/translation-context";
import { checkErrorMsg } from "../../utils/utils";

import { useDispatch, useSelector } from "react-redux";
import { fetchBankRates } from "../../store/slices/interestBearing/bkpReducer";

function BankPersonal() {
  const [isInEditMode, setIsInEditMode] = useState(false);
  const [editedRates, setEditedRates] = useState([]);
  const [isLoaderVisible, setIsLoaderVisible] = useState(false);
  const { translate: t } = useTranslation();
  const toastManager = ToastMessageFunction();
  const showToast = useCallback(
    (message, severity) => {
      toastManager.getToast(message, severity);
    },
    [toastManager]
  );

  const dispatch = useDispatch();
  const bkpState = useSelector((state) => state.bkpState);

  useEffect(() => {
    dispatch(fetchBankRates());
  }, [dispatch]);

  const enterEditMode = (value) => {
    setIsInEditMode(value);
  };

  const columns = useMemo(() => [
    {
      field: "rateType",
      width: 260,
      editable: false,
      renderHeader: () => <strong>Rate Type</strong>,
    },
    {
      field: "currency",
      width: 200,
      editable: false,
      renderHeader: () => <strong>Currency</strong>,
    },
    {
      field: "prePreviousMonthRate",
      width: 230,
      editable: false,
      renderHeader: () => {
        const prePreviousMonth = bkpState?.dates?.[0] || {};
        return (
          <strong>
            {t("priorToLastMonth")}
            <div>
              {prePreviousMonth.startDate} - {prePreviousMonth.endDate}
            </div>
          </strong>
        );
      },
      valueFormatter: (params) => {
        if (params === null || params === "") return <HorizontalRuleRounded />;
        else return Number(params).toFixed(2) + " %";
      },
      renderCell: ({ row }) => {
        if (!row) {
          return "not row";
        }
       
        if (row.prePreviousMonthRate === null) return <HorizontalRuleRounded />;
        console.log("row.prePreviousMonthRate", row.prePreviousMonthRate);
      },
    },
    {
      field: "previousMonthRate",
      width: 230,
      editable: false,
      renderHeader: () => {
        const previousMonth = bkpState?.dates?.[1] || {};
        return (
          <strong>
            {t("previousMonth")}
            <div>
              {previousMonth.startDate} - {previousMonth.endDate}
            </div>
          </strong>
        );
      },
      valueFormatter: (params) => {
        if (params === null || params === "") return <HorizontalRuleRounded />;
        else return Number(params).toFixed(2) + " %";
      },
      renderCell: ({ row }) => {
        if (!row) {
          return "not row";
        }
        if (row.previousMonthRate === null || row.previousMonthRate === "")
          return <HorizontalRuleRounded />;
      },
    },
    {
      field: "currentMonthRate",
      width: 230,
      editable: !bkpState?.isLocked,
      renderHeader: () => {
        const currentMonth = bkpState?.dates?.[2] || {};
        return (
          <strong>
            {t("currentMonth")}
            <div>
              {currentMonth.startDate} - {currentMonth.endDate}
            </div>
          </strong>
        );
      },
      valueFormatter: (params) => {
        if (params === null || params === "") return null;
        else return Number(params).toFixed(2) + " %";
      },
      renderCell: ({ row }) => {
        if (!row) {
          return "not row";
        }
        if (row.currentMonthRate === null || row.currentMonthRate === "")
          return <HorizontalRuleRounded />;
      },
      renderEditCell: (params) =>
        params.row.rateStatus ? (
          <GridEditInputCell
            {...params}
            value={params.value}
            onChange={(e) => {
              const inputValue = e.target.value;
              const regex = /^\d*\.?\d{0,2}$/;
              if (regex.test(inputValue) || inputValue === "") {
                params.api.setEditCellValue(
                  { id: params.id, field: "currentMonthRate", value: inputValue },
                  e
                );
                handleEditChange(params.id, "currentMonthRate", inputValue);
              }
            }}
          />
        ) : (
          params.row.currentMonthRate
        ),
    },
  ], [bkpState?.dates, bkpState?.isLocked, t]);

  const handleEditChange = (id, field, value) => {
    const editedItem =bkpState?.bankRates.find((rate) => rate.rateTypeId === id);

    if (editedItem && editedItem[field] !== value) {
      setEditedRates((prev) => {
        const isEdited = prev.some((rate) => rate.rateTypeId === id);
        if (isEdited) {
          return prev.map((rate) => {
            if (rate.rateTypeId === id) {
              return { ...rate, [field]: value };
            }
            return rate;
          });
        } else {
          return [...prev, { ...editedItem, [field]: value }];
        }
      });
    }
  };

  const handleSaveClick = () => {debugger;
    setIsLoaderVisible(true);

    putDataWAuth(IB_BKP_EDIT_RATES, editedRates)
      .then((res) => {
        if (res) {
          showToast(res.data.message, "success");
        }
        dispatch(fetchBankRates());
        setIsLoaderVisible(false);
      })
      .catch((error) => {
        showToast("Failed to save rates !", "error");
        setIsLoaderVisible(false);
      });
  };

  const handleEditModeError = (message) => {
    showToast(message, "error");
  };

  const handleLockClick = () => {debugger;
    setIsLoaderVisible(true);

    putDataWAuth(IB_BKP_FRZ_RATES, bkpState?.bankRates)
      .then((res) => {
        if (res) {
          showToast(res.data.message, "success");
          setInterval(() => {
            window.location.reload(false);
          }, 2000);
        }
      })
      .catch((error) => {
        if (checkErrorMsg(error)) showToast(checkErrorMsg(error), "error");
        else showToast(t("Failed to Lock rates !"), "error");
        setIsLoaderVisible(false);
      });
  };

  const getCustomRowId = (row) => row.rateTypeId;

  return (
    <div>
      {toastManager.toast}
      <div style={{ marginLeft: "20px" }}>
        <strong>{t("bankRates")}</strong>
      </div>
      <DataGrid
        view={APP_VIEW.BKP}
        isLocked={bkpState?.isLocked}
        editableAndFreezable={bkpState?.editableAndFreezable}
        getRowId={getCustomRowId}
        columns={columns}
        rows={bkpState?.bankRates}
        enterEditMode={enterEditMode}
        editToolBar={GridToolbar}
        isInEditMode={isInEditMode}
        editMode="batch"
        handleSaveClick={handleSaveClick}
        handleLockClick={handleLockClick}
        isLoaderVisible={isLoaderVisible}
        handleEditModeError={handleEditModeError}
      />
    </div>
  );
}

export default BankPersonal;